module.exports = __webpack_public_path__ + "static/img/Planificaciones_6_diseño universal@4x.8a33e9b5.png";